import { createTheme } from '@mui/material';

import { alertComponent } from './alert';
import { buttonComponent } from './button';
import { chipComponent } from './chip';
import { constantStyles } from './constantStyles';
import { formComponents } from './form';
import { inputOutlinedComponent } from './input';
import { linkComponent } from './link';
import { palette } from './palette';
import { shadows } from './shadows';
import { typography } from './typography';

declare module '@mui/material/styles' {
  interface Theme {
    constantStyles?: {
      paperBorder?: string;
      paperBorderRadius?: string;
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    constantStyles?: {
      paperBorder?: string;
      paperBorderRadius?: string;
    };
  }
}

export const theme = createTheme({
  palette,
  typography,
  shadows,
  components: {
    MuiAlert: alertComponent,
    MuiButton: buttonComponent,
    MuiChip: chipComponent,
    MuiLink: linkComponent,
    MuiOutlinedInput: inputOutlinedComponent,
    ...formComponents,
  },

  constantStyles,

  shape: {
    borderRadius: 4,
  },
});
